import { Typography, useTheme, Grid, IconButton } from '@mui/material'
import { tokens } from "../theme";

import AddModeratorIcon from '@mui/icons-material/AddModerator';
import RemoveModeratorIcon from '@mui/icons-material/RemoveModerator';
import DeleteIcon from '@mui/icons-material/Delete';

import ConfirmationWindow from './ConfirmationWindow';

import VerifyUser from '@mui/icons-material/PersonAddAlt1';
import UnverifyUser from '@mui/icons-material/PersonRemove';

import { useState } from 'react';

import { editUser, truncate } from '../utils/apiHelpers';

import { deleteUser } from '../utils/apiHelpers';

const UserElement = ({ user, userIndex, updateUserFunction }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	const [showConfirm, setShowConfirm] = useState(false);

	const handleDelete = async () => {
        await deleteUser(user);
        setShowConfirm(false);
        updateUserFunction();
    };

	return (
		<div>
			<Grid container
				alignItems="center"
				sx={{ backgroundColor: userIndex % 2 === 0 ? colors.gray[800] : colors.gray[700], width: '100%' }}>
				<Grid size={0.5}>
					<Typography
						variant="h6"
						color={colors.gray[100]}
						fontWeight="medium"
						sx={{ m: "0 0 0 10px" }}
					>
						{user.id}
					</Typography>
				</Grid>
				<Grid size={3.5}>
					<Typography
						variant="h4"
						color={colors.gray[100]}
						fontWeight="medium"
						sx={{ m: "0 0 0 10px" }}
					>
						{truncate(user.name, 10)}
					</Typography>
				</Grid>
				<Grid size={5}>
					<Typography
						variant="h4"
						color={colors.gray[100]}
						fontWeight="medium"
						sx={{ m: "0 0 0 10px" }}
					>
						{truncate(user.display_name, 10)}
					</Typography>
				</Grid>
				<Grid size={1}>
					<IconButton onClick={() => {
						const newUserData = {
							...user,
							verified: user.verified == 1 ? 0 : 1
						};
						editUser(newUserData).then(updateUserFunction)
					}}>
						{
							user.verified ? <UnverifyUser /> : <VerifyUser />
						}
					</IconButton>
				</Grid>
				<Grid size={1}>
					<IconButton onClick={() => {
						const newUserData = {
							...user,
							// Remove admin if admin, otherwise promote
							admin: user.admin == 1 ? 0 : 1
						};
						editUser(newUserData).then(updateUserFunction)
					}}>
						{
							// Show remove icon if admin and vice versa
							user.admin ? <RemoveModeratorIcon /> : <AddModeratorIcon />
						}
					</IconButton>
				</Grid>
				<Grid size={1}>
                    <IconButton onClick={() => setShowConfirm(true)}>
                        <DeleteIcon />
                    </IconButton>
				</Grid>
			</Grid>
			{showConfirm && (
                <ConfirmationWindow
                    title="Delete user?"
                    name={"Are you sure you want to delete user " + user.display_name + "?"}
                    colors={colors}
                    confirmFunction={handleDelete}
                    cancelFunction={() => setShowConfirm(false)}
                />
            )}
		</div>
	)
}

export default UserElement